import { render, staticRenderFns } from "./ProductByIdView.vue?vue&type=template&id=0c079565&scoped=true"
import script from "./ProductByIdView.vue?vue&type=script&lang=js"
export * from "./ProductByIdView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c079565",
  null
  
)

export default component.exports